@if (paymentReminderTypesWidgetData && initialized) {
    <mvs-widget [widgetData]="paymentReminderTypesWidgetData"></mvs-widget>
}
